import React from "react";

const CessationIcon = ({ className }) => {
  return (
    <div className={`${className}`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <ellipse
          cx="10"
          cy="10"
          rx="10"
          ry="10"
          transform="rotate(90 10 10)"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19 10C19 12.3869 18.0518 14.6761 16.364 16.364C14.6761 18.0518 12.3869 19 10 19C7.61305 19 5.32387 18.0518 3.63604 16.364C1.94821 14.6761 1 12.3869 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10ZM11.125 14.5C11.125 14.7984 11.0065 15.0845 10.7955 15.2955C10.5845 15.5065 10.2984 15.625 10 15.625C9.70163 15.625 9.41548 15.5065 9.2045 15.2955C8.99353 15.0845 8.875 14.7984 8.875 14.5C8.875 14.2016 8.99353 13.9155 9.2045 13.7045C9.41548 13.4935 9.70163 13.375 10 13.375C10.2984 13.375 10.5845 13.4935 10.7955 13.7045C11.0065 13.9155 11.125 14.2016 11.125 14.5ZM10 4.375C9.70163 4.375 9.41548 4.49353 9.2045 4.7045C8.99353 4.91548 8.875 5.20163 8.875 5.5V10C8.875 10.2984 8.99353 10.5845 9.2045 10.7955C9.41548 11.0065 9.70163 11.125 10 11.125C10.2984 11.125 10.5845 11.0065 10.7955 10.7955C11.0065 10.5845 11.125 10.2984 11.125 10V5.5C11.125 5.20163 11.0065 4.91548 10.7955 4.7045C10.5845 4.49353 10.2984 4.375 10 4.375Z"
          fill="#CB8989"
        />
      </svg>
    </div>
  );
};

export default CessationIcon;
